module.exports = __webpack_public_path__ + "static/media/1009843.34efe213.jpg";